import React, { useRef, useEffect } from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import { ArrowRight } from 'components/_ui/Arrow/ArrowRight';
import { ArrowLeft  } from 'components/_ui/Arrow/ArrowLeft';
import AOS from 'aos';
import TestimonialCard from './TestimonialCard';

import ALASTAIR from 'resources/images/jpeg/alastair-smith-135x135.jpg';
import BELLAHARDINGE from 'resources/images/jpeg/bella-hardinge-135x135.jpg';
import MARKSICOLA from 'resources/images/jpeg/mark-sicola-135x135.jpg';
import EDUARDOALMODOVAR from 'resources/images/jpeg/eduardo-almodovar-135x135.jpg';
import DANNYALVAREZ from 'resources/images/jpeg/danny-chino-alvarez-135x135.jpg';
import FEMALE from 'resources/images/jpeg/female-avatar-135x135.jpg';
import MALE from 'resources/images/jpeg/male-avatar-135x135.jpg';

import './testimonialSlider.scss';

import SwiperCore, { Navigation, Autoplay } from 'swiper';
SwiperCore.use([Navigation, Autoplay]);

export const TestimonialSlider = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 900, mirror: true });
  }, []);

  const data = [
    {
      img: ALASTAIR,
      name: "Alastair Smith",
      position: "Chief Executive Officer",
      businessName: "Outdesk, AU",
      message:
        "“Working with the team has significantly streamlined our design process. Projects are delivered on time, aligned with our brand, and require far less back-and-forth. It’s been a reliable, efficient partnership.”",
    },
    {
      img: BELLAHARDINGE,
      name: "Bella Hardinge",
      position: "Head of Operations",
      businessName: "London, UK",
      message:
        "“Really Professional, and a Super Quick Turnaround. Lots of Exciting, and On-Brand Ideas.”",
    },
    {
      img: MARKSICOLA,
      name: "Mark Sicola",
      position: "Entrepreneur/Content Creator",
      businessName: "The Mark List, California",
      message:
        "“He took the time to look at what I wanted and delivered exactly what I envisioned.”",
    },
    {
      img: EDUARDOALMODOVAR,
      name: "Eduardo Almodovar",
      position: "Real Estate Marketer",
      businessName: "Focuzz™, Puerto Rico",
      message:
        "“100% Recommended. Very professional, good communication throughout every step, he exceeded all my expectations.”",
    },
    {
      img: DANNYALVAREZ,
      name: "Danny Alvarez",
      position: "Business Owner/Pro Surfer",
      businessName:
        "DieselTech Services, LLC / DieselJunkie™",
      message:
        "“Professionalism, quality, efficiency, and skills that truly stand out!”",
    },
    {
      img: FEMALE,
      name: "Olivia S.",
      position: "Entrepreneur",
      businessName: "Start-Up, France",
      message:
        "“Putting up a start-up becomes so much easier when you have this level of support—highly recommended!”",
    },
    {
      img: MALE,
      name: "Jessie A.",
      position: "Business Owner/Rapper",
      businessName: "Toronto, Canada",
      message:
        "“When I sent a request, I had my final files in under an hour. Unreal turnaround!”",
    },
    {
      img: MALE,
      name: "Alexander G.",
      position: "Business Owner",
      businessName: "ProPower, USA",
      message:
        "“Great work, was very responsive and hit the brief perfectly.”",
    },
  ];

  const params = {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    autoplay: { delay: 5000, disableOnInteraction: true },
    autoHeight: false, // NEW: stop resizing by tallest slide
    initialSlide: 0,
  };

  const slidePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const slideNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <div className="testimonial_slider">
      <div className="arrow-wrap left" onClick={slidePrev}>
        <ArrowLeft />
      </div>

      <div
        className="innerSlider"
        data-aos="fade-right"
        data-aos-offset="-200"
        data-aos-delay="200"
        data-aos-duration="700"
      >
        <Swiper {...params} ref={swiperRef}>
          {data.map((item, idx) => (
            <div key={idx} className="slide">
              <TestimonialCard
                img={item.img}
                message={item.message}
                name={item.name}
                position={item.position}
                businessName={item.businessName}
              />
            </div>
          ))}
        </Swiper>
      </div>

      <div className="arrow-wrap right" onClick={slideNext}>
        <ArrowRight />
      </div>
    </div>
  );
};
